const axios = require("axios");
import $ from "jquery";

const testForms = document.querySelectorAll(".form_js-validate");

const isLocal = (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "");

function setError(e, status) {
    if (status) {
        $(e).addClass("is-error");
        $(e).closest(".form__field").find(".input-error").removeClass("hidden");
    } else {
        $(e).removeClass("is-error").removeClass("is-correct");
        $(e).closest(".form__field").find(".input-error").addClass("hidden");
    }
}

function onlyNumbersAndDelete(event) {
    // Allow: backspace, delete, tab, escape, enter, dot, numbers, padNumbers, arrowLeft and Right
    var allowedKeys = [
        8, 46, 9, 27, 13, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98,
        99, 100, 101, 102, 103, 104, 105, 37, 39,
    ];

    // Allow: Ctrl+A, Command+A
    if (
        (event.ctrlKey === true || event.metaKey === true) &&
        (event.which === 65 || event.which === 97)
    ) {
        return true;
    }

    // Ensure that it is a number or dot or comma
    var charCode = event.which ? event.which : event.keyCode;
    if (allowedKeys.indexOf(charCode) === -1) {
        event.preventDefault();
    }

    // Ensure that there is only one dot or comma
    var input = event.target.value;

    const enteringNum = event["key"];
    const currentValue = input;
    const maxLength =
        parseInt(event.target.getAttribute("maxlength"), 10) || 99999999;

    if (!isNaN(enteringNum)) {
        // console.log(maxLength);
        const newVal = currentValue.toString() + enteringNum;
        if (+newVal.length > maxLength) {
            event.preventDefault();
        }
    }
}

function toggleModal(id, action) {
    const modal = document.getElementById(id);
    if (!modal) return;
    const form = document.querySelector(".form_js-validate");
    const modalClose = modal.querySelector(".modal__close");
    const modalOverlay = modal.querySelector(".modal__overlay");
    const modalContent = modal.querySelector(".modal__inner");

    [modalOverlay, modalClose].forEach((el) => {
        el.addEventListener("click", () => {
            toggleModal(id, "close");
            // console.log(form);
            form.classList.remove("is-sending");
            // if (el.closest(".modal").id === "invalidCode") {
            //     // console.log('invalidCode');
            //     const errorBarcodeIncorrect = document.querySelector(
            //         ".error-barcode-incorrect",
            //     );
            //     const field = document.querySelector("#barcode");
            //     field.value = "";
            //     field.classList.add("input-error");
            //     errorBarcodeIncorrect.classList.remove("hidden");
            // }
        });
    });

    if (action === "open") {
        document.body.classList.toggle("show-modal");
        modal.classList.add("is-open");
    } else {
        document.body.classList.remove("show-modal");
        modal.classList.remove("is-open");
    }
}

if (testForms?.length > 0) {
    let timeStart = 0;

    document.addEventListener("DOMContentLoaded", function () {
        timeStart = Date.now();
    });

    window.formComponent = {
        init: () => {
            testForms.forEach((form) => {
                const fields = form.querySelectorAll("[data-validate]");
                formComponent.validationOnSubmit(fields, form);
                formComponent.checkActive(fields, form);
                formComponent.validateOnEntry(fields, form);
            });
        },

        modelValidation: (validationFields, form) => {
            validationFields.forEach((field) => {
                formComponent.validateFields(field);
            });
            let checks = form.querySelector(".error:not(.hidden)");
            if (form.contains(checks)) {
                // here you can add some error msg or else ...
            } else {
                formSending(form);
            }
        },
        checkActive: (validationFields, form) => {
            validationFields.forEach((field) => {
                field.onfocus = function () {
                    let pseudoLabel = field
                        .closest(".form__field")
                        .querySelector(".form__label");
                    field
                        .closest(".form__field")
                        .classList.add("form__field_active");
                };
                field.onblur = function () {
                    if (field.value == "")
                        field
                            .closest(".form__field")
                            .classList.remove("form__field_active");
                };
            });
        },

        validationOnSubmit: (validationFields, form) => {
            form.addEventListener("submit", (e) => {
                e.preventDefault();

                formComponent.modelValidation(validationFields, form);
            });
        },

        validateOnEntry: (validationFields, form) => {
            validationFields.forEach((field) => {
                field.addEventListener("input", (event) => {
                    formComponent.validateFields(field);
                });
                if (field.id === "question2") {
                    field.addEventListener("keydown", onlyNumbersAndDelete);
                }
                // if (field.id === "barcode" || field.id === "question2") {
                //     field.addEventListener("keydown", onlyNumbersAndDelete);
                // }
            });
        },

        validateFields: (input) => {
            const data = input.dataset.validate;

            if (~data.indexOf("no-empty")) {
                if (input.value.trim() === "") {
                    formComponent.setStatus(input, "error");
                } else {
                    formComponent.setStatus(input, "success");
                }
            }
            if (~data.indexOf("number")) {
                const numReg = /^\d+$/;
                if (numReg.test(input.value) && input.value.trim() !== "") {
                    formComponent.setStatus(input, "success");
                } else {
                    formComponent.setStatus(input, "error");
                }
            }
            if (~data.indexOf("email")) {
                const emailReg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;
                if (emailReg.test(input.value) && input.value.trim() !== "") {
                    formComponent.setStatus(input, "success");
                } else {
                    formComponent.setStatus(input, "error");
                }
            }

            if (~data.indexOf("select")) {
                if (input.value === "") {
                    formComponent.setStatus(input, "error");
                } else {
                    formComponent.setStatus(input, "success");
                }
            }
            if (~data.indexOf("checkbox")) {
                // console.log(input.checked);
                if (input.checked) {
                    formComponent.setStatus(input, "success");
                } else {
                    formComponent.setStatus(input, "error");
                }
            }

            if (~data.indexOf("phone")) {
                const phoneReg =
                    /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm;
                if (phoneReg.test(input.value) && input.value.trim() !== "") {
                    formComponent.setStatus(input, "success");
                } else {
                    formComponent.setStatus(input, "error");
                }
            }
        },

        // set/remove class final fx
        setStatus: (field, status) => {
            const errorMessage = field.parentElement.querySelector(".error");

            if (status === "success") {
                field.classList.remove("input-error");
                if (field.id === "barcode") {
                    const errorBarcodeIncorrect =
                        field.parentElement.querySelector(
                            ".error-barcode-incorrect",
                        );
                    const errorBarcodeEmpty = field.parentElement.querySelector(
                        ".error-barcode-empty",
                    );
                    errorBarcodeIncorrect.classList.add("hidden");
                    errorBarcodeEmpty.classList.add("hidden");
                } else {
                    errorMessage.classList.add("hidden");
                }
            }
            if (status === "error") {
                field.classList.add("input-error");
                if (field.id === "barcode") {
                    const errorBarcodeEmpty = field.parentElement.querySelector(
                        ".error-barcode-empty",
                    );
                    errorBarcodeEmpty.classList.remove("hidden");
                } else {
                    errorMessage.classList.remove("hidden");
                }
            }
        },
    };

    formComponent.init();

    async function sendingForm(fData, action) {
        try {
            let res = await axios({
                method: "post",
                url: action,
                data: fData,
                headers: { "Content-Type": "application/json" },
            });
            return res;
        } catch (error) {
            console.log(error.response);

            return error.response;
        }
    }

    const barcode = $("#barcode"),
          question1 = document.querySelectorAll('input[name="question1"]'),
          msq = $("#msq");

    let selectRadio = false;
    
    function showError() {
        if (this.checked) {
            selectRadio = true;
            $(msq).next().addClass("hidden");
            localStorage.setItem('question1', this.value);
            localStorage.setItem('question_id', document.querySelector('#questionID').value);
        } else {
            $(msq).next().removeClass("hidden");
        }
    }

    for (const radioButton of question1) {
        radioButton.addEventListener("change", showError.bind(radioButton));
    }

    function formHandlerStep3() {
        if (!selectRadio) {
            $(msq).next().removeClass("hidden");
        }
    }

    if ($(".form__step3")) {
        $(".form__step3").on("submit", () => {
            formHandlerStep3();
            if (selectRadio) {
                window.location.href = $(".form__step3").attr('action');
            }
        });
    }

    async function formSending(form) {
        let thankPage = "thanks";
        let action = form.action;

        // - Barcode step
        if (form.classList.contains("form__step2")) {
            const btnSubmit = document.querySelector('#btnSubmit'),
                btnPrev = document.querySelector('#btnPrev');

            btnSubmit.setAttribute('disabled', 'disabled');
            btnPrev.setAttribute('disabled', 'disabled');

            const codeData = {
                code: String($(barcode).val())
            };

            if (isLocal) {
                form.classList.add("is-sending");
                localStorage.setItem("code", $(barcode).val());
                console.table(codeData);
                // for (var pair of Object.entries(codeData)) {
                //     console.log(pair[0] + ', ' + pair[1]);
                // }
                window.setTimeout(function () {
                    form.classList.remove("is-sending");
                    btnSubmit.removeAttribute('disabled', '');
                    btnPrev.removeAttribute('disabled', '');
                    // toggleModal("invalidCode", "open");
                    window.location.href = $(form).attr('data-redirect');
                }, 5000);
                return;
            }

            sendingForm(codeData, action).then((res) => {
                form.classList.add("is-sending");
                localStorage.setItem("code", $(barcode).val());
                console.table(codeData);
                if (res.status === 200) {
                    if (!res.data.codeIsValid) {
                        toggleModal("invalidCode", "open");
                        form.classList.remove("is-sending");
                        btnSubmit.removeAttribute('disabled', '');
                        btnPrev.removeAttribute('disabled', '');
                        return;
                    }
                    window.location.href = $(form).attr('data-redirect');
                } else {
                    toggleModal("invalidForm", "open");
                    form.classList.remove("is-sending");
                    btnSubmit.removeAttribute('disabled', '');
                    btnPrev.removeAttribute('disabled', '');
                }
            });
        }

        if (form.classList.contains("form__step4")) {
            sendingForm().then(() => {
                localStorage.setItem("question2", $('#question2').val());
                window.location.href = $(form).attr('action');
            });
        }

        // - Participation form
        if (form.classList.contains("form__participate")) {
            const btnSubmit = document.querySelector('#btnSubmit'),
                  btnPrev = document.querySelector('#btnPrev');

            btnSubmit.setAttribute('disabled', 'disabled');
            btnPrev.setAttribute('disabled', 'disabled');

            // const token = await grecaptcha.execute(tokenCaptcha, {
            //     action: "submit",
            // });

            const newFormData = {
                code: String(localStorage.getItem("code")),
                answer: String(localStorage.getItem("question1")),
                question_id: Number(localStorage.getItem("question_id")),
                tie_breaker_question: Number(localStorage.getItem("question2")),
                first_name: String(form.querySelector("#name").value),
                last_name: String(form.querySelector("#surname").value),
                email: String(form.querySelector("#email").value),

                privacy: Boolean(form.querySelector("#agree_privacy").checked),
                newsletter: Boolean(form.querySelector("#newsletter").checked),
                third_party_consent: Boolean(form.querySelector("#third_party_consent").checked),
                // "g-recaptcha-response": token,
            };

            if (isLocal) {
                form.classList.add("is-sending");
                console.table(newFormData);
                for (var pair of Object.entries(newFormData)) {
                    console.log(pair[0] + ', ' + pair[1]);
                }
                window.setTimeout(function () {
                    form.classList.remove("is-sending");
                    btnSubmit.removeAttribute('disabled', '');
                    btnPrev.removeAttribute('disabled', '');
                    // localstorage clear
                    // localStorage.removeItem("code");
                    // localStorage.removeItem("question1");
                    // localStorage.removeItem("question2");
                    // localStorage.removeItem("question_id");

                    // window.location.href = thankPage + `.html?lang=${LANG}`;
                }, 5000);
                return;
            }

            sendingForm(newFormData, action).then((res) => {
                console.table(newFormData);
                form.classList.add("is-sending");
                if (res.status === 200) {
                    form.classList.remove("is-sending");
                    btnSubmit.removeAttribute('disabled', '');
                    btnPrev.removeAttribute('disabled', '');

                    // localstorage clear
                    localStorage.removeItem("code");
                    localStorage.removeItem("question1");
                    localStorage.removeItem("question2");
                    localStorage.removeItem("question_id");

                    window.location.href = thankPage + `?lang=${LANG}`;
                } else if (res.status === 400) {
                    if (res.data.errors.some(error => error._tag === 'invalid-code')) {
                        toggleModal("invalidCode", "open");
                        form.classList.remove("is-sending");
                        btnSubmit.removeAttribute('disabled', '');
                        btnPrev.removeAttribute('disabled', '');
                        return;
                    }
                    if (res.data.errors.some(error => error._tag === 'invalid-question')) {
                        toggleModal("invalidQuestion", "open");
                        form.classList.remove("is-sending");
                        btnSubmit.removeAttribute('disabled', '');
                        btnPrev.removeAttribute('disabled', '');
                        return;
                    }
                } else {
                    toggleModal("invalidForm", "open");
                    form.classList.remove("is-sending");
                    btnSubmit.removeAttribute('disabled', '');
                    btnPrev.removeAttribute('disabled', '');
                }
                const fieldsWithJs = form.querySelectorAll(".form__field");
                fieldsWithJs.forEach((field) => {
                    field.classList.remove("form__field_active");
                });
            });
        }
    }
}
